import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosPrivate } from '../hooks/axiosInstance';

// Async thunks
export const getRoleLimits = createAsyncThunk(
  'limiter/getRoleLimits',
  async (_, thunkAPI) => {
    try {
      console.log('Fetching role limits from: /role-limits');
      const response = await axiosPrivate.get('/role-limits');
      console.log('Role limits response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching role limits:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      return thunkAPI.rejectWithValue(
        error.response?.data || { msg: 'Failed to fetch role limits' }
      );
    }
  }
);

export const updateRoleLimits = createAsyncThunk(
  'limiter/updateRoleLimits',
  async (roleLimits, thunkAPI) => {
    try {
      const response = await axiosPrivate.put('/role-limits', {
        roleLimits
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { msg: 'Failed to update role limits' }
      );
    }
  }
);

const limiterSlice = createSlice({
  name: 'limiter',
  initialState: {
    roleLimits: {},
    currentCounts: {},
    managedBy: null,
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    resetLimiter: (state) => {
      state.roleLimits = {};
      state.currentCounts = {};
      state.managedBy = null;
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get role limits
      .addCase(getRoleLimits.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRoleLimits.fulfilled, (state, action) => {
        state.loading = false;
        state.roleLimits = action.payload.roleLimits;
        state.currentCounts = action.payload.currentCounts;
        state.managedBy = action.payload.managedBy;
        state.error = null;
      })
      .addCase(getRoleLimits.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.msg || 'Failed to fetch role limits';
      })
      // Update role limits
      .addCase(updateRoleLimits.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateRoleLimits.fulfilled, (state, action) => {
        state.loading = false;
        state.roleLimits = action.payload.roleLimits;
        state.success = true;
        state.error = null;
      })
      .addCase(updateRoleLimits.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.msg || 'Failed to update role limits';
        state.success = false;
      });
  },
});

export const { clearError, clearSuccess, resetLimiter } = limiterSlice.actions;

export default limiterSlice.reducer;